import React from 'react'
import { Link } from 'gatsby'
import styled, { keyframes } from 'styled-components'
import { Parallax } from 'react-scroll-parallax'

import {
  FlexContainer,
  Container,
  OutlineCircle,
  FilledCircle,
  Button,
} from '../elements'
import Gear from './gear'
import { getImage } from '../imageContainers'
import {
  section1,
  section2,
  section3,
  section4,
  PricingCard,
} from '../CMS/Product'

const bounce = keyframes`
    0%   { transform: scale(1,1)      translateY(0); }
    10%  { transform: scale(1.1,.9)   translateY(0); }
    30%  { transform: scale(.9,1.1)   translateY(-70px); }
    50%  { transform: scale(1.05,.95) translateY(0); }
    57%  { transform: scale(1,1)      translateY(-7px); }
    64%  { transform: scale(1,1)      translateY(0); }
    100% { transform: scale(1,1)      translateY(0); }
`

const Tour = ({ className, lang }) => (
  <Container className={className}>
    <FlexContainer
      direction="column"
      alignItems="center"
      justifyContent="center"
      width="60%"
      flexWrap="wrap"
      minHeight="50vh"
      alignSelf="center"
      margin="5rem auto 3rem"
      className="smallScreen"
    >
      <h1 className="main-heading text-center" dir="auto">
        <FilledCircle
          top="-0.5rem"
          right="-3rem"
          size="78px"
          small_right="20%"
          duration="6s"
        />
        {section1[lang].title}
      </h1>
      <p className="text-center" dir="auto">
        {' '}
        {section1[lang].subtitle}
      </p>
    </FlexContainer>

    <FlexContainer
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      flexWrap="wrap"
      minHeight="30rem"
      className="mobileRow"
      margin="0 auto 15rem auto"
    >
      <FlexContainer
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        width="48%"
        minHeight=" 100%"
        className="row-half"
      >
        <FlexContainer
          width="90%"
          direction="column"
          className="smallScreen"
          padding="0 0 0 30px"
        >
          <h1 dir="auto">{section2[lang].title}</h1>
          <p className="relative" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
            {section2[lang].text}
          </p>
          <OutlineCircle
            top="0px"
            left="-3rem"
            size="112"
            small_top="3rem"
            small_left="0rem"
            thickness="5"
            duration="30s"
            innerposition="2.5px"
          />
        </FlexContainer>
        <ul>
          {section2[lang].list.map(item => (
            <li key={item.text} dir="auto">
              <div className="li-img">
                {getImage(`${item.icon ? item.icon : 'block'}.png`)}
              </div>
              {item.text}
            </li>
          ))}
        </ul>
      </FlexContainer>

      <Gear
        size="50"
        bottom="-1rem"
        left="44%"
        small_bottom="-3rem"
        small_right="8%"
        small_left="unset"
      />

      <Gear
        size="30"
        bottom="1.5rem"
        left="50%"
        small_bottom="1rem"
        small_right="2%"
        small_left="unset"
      />

      <FlexContainer
        direction="column"
        alignItems="center"
        justifyContent="flex-end"
        width="48%"
        minHeight="130%"
        className="row-half"
        alignSelf="flex-end"
      >
        <div className="contact-block">
          <FilledCircle
            top="26%"
            left="45%"
            size="161px"
            small_left="35%"
            small_top="22%"
            duration="10s"
          />
          <div className="meliorSubmit">
            <Parallax y={['-120px', '32px']}>
              {getImage(section2[lang].img)}
            </Parallax>
          </div>
        </div>
      </FlexContainer>
    </FlexContainer>
    <FlexContainer
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      flexWrap="wrap"
      height="40rem"
      minHeight="30rem"
      className="mobileRow desktop-row"
      margin="15rem auto"
    >
      <FlexContainer
        direction="column"
        alignItems="center"
        justifyContent="flex-end"
        width="28%"
        maxHeight="10px"
        className="row-half relative"
        alignSelf="flex-end"
      >
        <Parallax y={['-300px', '300px']} className="parallex">
          <OutlineCircle
            bottom="12rem"
            left="-5rem"
            size="112"
            small_left="0rem"
            thickness="5"
            innerposition="2.5px"
            duration="30s"
          />
        </Parallax>
      </FlexContainer>

      <FlexContainer
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        width="70%"
        minHeight="30rem"
        className="row-half desktop"
      >
        <div className="desktop-img">
          <Parallax y={['-50px', '35px']}>
            {getImage(section3[lang].img)}
          </Parallax>
        </div>
        <div className="desktop-text">
          <FlexContainer
            width="90%"
            direction="column"
            className="smallScreen"
            padding="0 0 0 30px"
          >
            <h2 dir="auto">{section3[lang].title}</h2>
            {section3[lang].text && (
              <p className="relative" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
                {section3[lang].text}
              </p>
            )}
          </FlexContainer>
          <ul>
            {section3[lang].list.map(item => (
              <li key={item.text} dir="auto">
                <div className="li-img">
                  {getImage(`${item.icon ? item.icon : 'block'}.png`)}
                </div>
                {item.text}
              </li>
            ))}
          </ul>
        </div>
      </FlexContainer>
      <div className="wire">
        <Parallax y={['-300px', '200px']}>{getImage('wire.png')}</Parallax>
      </div>
    </FlexContainer>

    <FlexContainer
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      flexWrap="wrap"
      minHeight="30rem"
      className="mobileRow"
      margin="15rem auto"
      dir={lang === 'ar' ? 'rtl' : 'auto'}
    >
      <FlexContainer
        direction="column"
        alignItems="flex-start"
        justifyContent="flex-start"
        width="34rem"
        minHeight=" 30rem"
        className="row-half product"
        padding="40px 30px"
      >
        <FlexContainer
          width="70%"
          direction="column"
          className="smallScreen"
          padding="0 0 0 30px"
        >
          <h2 className="product-heading" dir="auto">
            {section4[lang].title}
          </h2>
          {section4[lang].text && (
            <p className="relative" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
              {section4[lang].text}
            </p>
          )}
          <ul>
            {section4[lang].list.map(item => (
              <li key={item.text} dir="auto">
                <div className="li-img">
                  {getImage(`${item.icon ? item.icon : 'block'}.png`)}
                </div>
                {item.text}
              </li>
            ))}
            <div className="product-img">
              <Parallax y={['-80px', '50px']}>
                {getImage(section4[lang].img)}
              </Parallax>

              <FilledCircle
                left={lang === 'ar' ? 'unset' : '59%'}
                right={lang === 'ar' ? '59%' : 'unset'}
                top="59%"
                size="181px"
                small_left={lang === 'ar' ? 'unset' : '35%'}
                small_right={lang === 'ar' ? '35%' : 'unset'}
                small_top="22%"
                medium_left={lang === 'ar' ? 'unset' : '56%'}
                medium_right={lang === 'ar' ? '56%' : 'unset'}
                medium_top="56%"
                duration="8s"
                delay="0.5s"
              />
            </div>
          </ul>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
    <FlexContainer
      direction="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      minHeight="30rem"
      alignSelf="center"
      margin="5rem auto 0"
      className="smallScreen relative"
    >
      <FlexContainer
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        width="35rem"
        flexWrap="wrap"
        alignSelf="center"
        margin="auto"
        className="see-pricing fullScreen-price"
        dir={lang === 'ar' ? 'rtl' : null}
        style={lang === 'ar' ? { textAlign: 'right' } : null}
      >
        <FlexContainer
          direction="column"
          width="50%"
          className="fullScreen-price"
        >
          <div className="hand-img">{getImage(PricingCard[lang].img)}</div>
          <h2 className="main-heading" dir="auto">
            {PricingCard[lang].title}
          </h2>
          <p dir="auto">{PricingCard[lang].subtitle}</p>
        </FlexContainer>

        <Button className="price-button">
          <Link to="/pricing" dir="auto">
            {PricingCard[lang].button}
          </Link>
        </Button>
      </FlexContainer>
      <Parallax y={['-200px', '200px']}>
        <OutlineCircle
          fill="alternate"
          top="-5rem"
          left="-19rem"
          size="191"
          small_top="-15rem"
          small_left="-2rem"
          thickness="5"
          innerposition="2.5px"
          duration="20s"
        />

        <OutlineCircle
          bottom="10rem"
          left="3rem"
          size="54"
          small_top="-20rem"
          small_left="0rem"
          duration="30s"
          delay="0.4s"
          fill="alternate"
          thickness="5"
          innerposition="2.5px"
        />
      </Parallax>
      <div className="stats">
        <Parallax y={['-300px', '300px']}>{getImage('stats.png')}</Parallax>
      </div>
    </FlexContainer>
  </Container>
)

export default styled(Tour)`
  .product-heading {
    width: 90%;
  }
  .main-heading {
    position: relative;
    color: #000;
  }
  .relative {
    position: relative;
  }
  .parallex {
    z-index: -20;
    * {
      z-index: -20;
    }
  }
  .meliorSubmit {
    max-width: 350px;
    margin: 0 auto;
  }
  Button {
    &:hover {
      background: ${props => props.theme.colors.white};
      color: ${props => props.theme.colors.yellowMelior};
      transition: 0.2s;
      box-shadow: inset 0 0 0 2px ${props => props.theme.colors.yellowMelior};
    }
    z-index: 2;
  }
  .text-center {
    text-align: center;
  }
  .price-button {
    padding: 0;
    height: 50px;
    width: 40%;
    align-self: flex-end;
    a {
      color: inherit;
      width: 100%;
      height: 55px;
      padding: 15px;
      margin: 0;
      font-size: 20px;
      font-weight: bold;
    }
  }
  h1,
  h2 {
    color: ${props => props.theme.colors.yellowMelior};
    z-index: 4;
    text-align: ${props => (props.lang === 'ar' ? 'right' : 'left')};
  }
  p {
    font-size: 1.5rem;
    line-height: 28px;
    font-weight: 300;
    font-family: ${props => props.theme.fonts['Helvetica-light']};
    z-index: 2;
    text-align: ${props => (props.lang === 'ar' ? 'right' : 'left')};
  }
  ul {
    margin-right: ${props => (props.lang === 'ar' ? '3rem' : '0')};
    text-align: ${props => (props.lang === 'ar' ? 'right' : 'left')};
    margin-left: 0;
    z-index: 2;
  }
  .hand-img {
    width: 75px;
    margin-bottom: 10px;
  }
  .see-pricing {
    border: 1px solid ${props => props.theme.colors.gearGrey};
    border-radius: 20px;
    box-shadow: 0 0 3px rgba(1, 1, 1, 0.75);
    padding: 30px 60px;
    z-index: 2;
    * {
      filter: unset;
    }
    p {
      text-align: ${props => (props.lang === 'ar' ? 'right' : 'left')};
    }
    &:hover .hand-img {
      animation-duration: 1.8s;
      animation-name: ${bounce};
      animation-timing-function: cubic-bezier(0.28, 0.84, 0.42, 1);
    }
  }
  li {
    z-index: 4;
    padding-left: 30px;
    font-size: 1rem;
    line-height: 25px;
    font-weight: bold;
    position: relative;
    font-family: ${props => props.theme.fonts['Helvetica-light']};
  }
  .li-img {
    width: 20px;
    margin: 0 auto;
    position: absolute;
    left: ${props => (props.lang === 'ar' ? 'unset' : '0px')};
    right: ${props => (props.lang === 'ar' ? '-25px' : 'unset')};
    top: 5px;
    &.star {
      width: 18px;
    }
  }

  .contact-block {
    width: 90%;
    position: relative;
  }
  .row-half {
    position: relative;
  }
  .mobileRow {
    position: relative;
  }
  .desktop {
    border-radius: 7px;
    min-height: 100%;
  }
  .desktop-text {
    position: absolute;
    background: ${props => props.theme.colors.grey};
    padding-top: 7rem;
    padding-left: 13rem;
    padding-bottom: 1rem;
    bottom: 2rem;
    right: 0rem;
    width: 100%;
  }
  .desktop-img {
    width: 95%;
    max-width: 800px;
    position: absolute;
    top: -8.5%;
    left: -44%;
    z-index: 1;
    margin: 0 auto;
  }
  .wire {
    z-index: -5;
    width: 16rem;
    bottom: 0;
    left: -23%;
    position: relative;
  }
  .stats {
    z-index: 0;
    width: 12rem;
    position: absolute;
    bottom: 0;
    right: -20%;
  }

  .desktop-row {
    z-index: 1;
  }
  .product-img {
    width: ${props => (props.lang === 'ar' ? '275%' : '275%')};
    position: absolute;
    bottom: ${props => (props.lang === 'ar' ? '-29rem' : '-23rem')};
    left: ${props => (props.lang === 'ar' ? 'unset' : 0)};
    right: ${props => (props.lang === 'ar' ? 0 : 'unset')};
    margin: 0 auto;
  }
  .product {
    background: ${props => props.theme.colors.grey};
    border-radius: 7px;
    ul {
      position: relative;
      margin-right: ${props => (props.lang === 'ar' ? '1rem' : 'auto')};
    }
    h2 {
      font-size: 1.6rem;
    }
    li {
      z-index: 3;
    }
  }
  @media (max-width: 1030px) {
    .product-img {
      width: 200%;
      bottom: ${props => (props.lang === 'ar' ? '-21rem' : '-15rem')};
      left: ${props => (props.lang === 'ar' ? 'unset' : 0)};
      right: ${props => (props.lang === 'ar' ? 0 : 'unset')};
    }
    .stats {
      right: -8%;
    }
    .wire {
      left: -8%;
    }

    .desktop-text {
      padding-left: 1rem;
    }
  }
  @media (max-width: 620px) {
    .price-button {
      width: 100%;
      a {
        width: 100%;
      }
    }
    .see-pricing {
      padding: 40px 30px;
    }
    .fullScreen-price {
      width: 100%;
    }
    .smallScreen {
      padding: 0;
      width: 100%;
      z-index: 2;
    }
    .mobileRow {
      flex-wrap: wrap-reverse;
      margin: 15rem auto 0;
    }
    .desktop-row {
      z-index: 1;
      margin-top: 15rem;
    }
    .row-half {
      width: 100%;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      padding: 0;
      background: transparent;
      z-index: 3;
    }
    .wire {
      bottom: unset;

      top: 35rem;
      left: -15%;
    }
    .stats {
      right: 0;
    }
    .product-img {
      width: 100%;
      bottom: unset;
      top: -28.5rem;
      left: ${props => (props.lang === 'ar' ? 'unset' : '-1rem')};
      right: ${props => (props.lang === 'ar' ? '-1rem' : 'unset')};
    }
    .product {
      margin-top: 10rem;
      padding: 0;
      background: transparent;
      min-height: 62vh;
      z-index: 3;

      h2 {
        font-size: 1.62671rem;
      }
    }
    .desktop-img {
      position: unset;
      width: 100%;
    }
    .desktop-text {
      position: relative;
      width: 100%;
      bottom: unset;
      z-index: 3;
      background: transparent;
      right: unset;
      padding: 10px;
    }
    ul {
      margin-right: ${props => (props.lang === 'ar' ? '1rem' : 'auto')};
    }
  }
`
